import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EditMode, NextImage as SitecoreNextImage, Link as SitecoreLink, Text, useSitecore } from '@sitecore-content-sdk/nextjs';
const ImageDefault = (props)=>/*#__PURE__*/ _jsx("div", {
        className: `component image ${props?.params?.styles}`.trimEnd(),
        children: /*#__PURE__*/ _jsx("div", {
            className: "component-content",
            children: /*#__PURE__*/ _jsx("span", {
                className: "is-empty-hint",
                children: "Image"
            })
        })
    });
export const Banner = (props)=>{
    const id = props.params.RenderingIdentifier;
    const { page } = useSitecore();
    const isPageEditing = page.mode.isEditing;
    const editMode = page.layout.sitecore.context?.editMode;
    const isMetadataMode = editMode === EditMode.Metadata;
    const classHeroBannerEmpty = isPageEditing && props.fields?.Image?.value?.class === 'scEmptyImage' ? 'hero-banner-empty' : '';
    const backgroundStyle = props?.fields?.Image?.value?.src && {
        backgroundImage: `url('${props.fields.Image.value.src}')`
    };
    const modifyImageProps = !isMetadataMode ? {
        ...props.fields.Image,
        editable: props?.fields?.Image?.editable?.replace(`width="${props?.fields?.Image?.value?.width}"`, 'width="100%"').replace(`height="${props?.fields?.Image?.value?.height}"`, 'height="100%"')
    } : {
        ...props.fields.Image,
        value: {
            ...props.fields.Image.value,
            style: {
                width: '100%',
                height: '100%'
            }
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: `component hero-banner ${props?.params?.styles} ${classHeroBannerEmpty}`,
        id: id ? id : undefined,
        children: /*#__PURE__*/ _jsx("div", {
            className: "component-content sc-sxa-image-hero-banner",
            style: backgroundStyle,
            children: isPageEditing ? /*#__PURE__*/ _jsx(SitecoreNextImage, {
                field: modifyImageProps
            }) : ''
        })
    });
};
export const Default = (props)=>{
    const { page } = useSitecore();
    if (props.fields) {
        const InlineImage = ()=>/*#__PURE__*/ _jsx(SitecoreNextImage, {
                field: props.fields.Image
            });
        const id = props.params.RenderingIdentifier;
        return /*#__PURE__*/ _jsx("div", {
            className: `component image ${props?.params?.styles}`,
            id: id ? id : undefined,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "component-content",
                children: [
                    page.mode.isEditing || !props.fields.TargetUrl?.value?.href ? /*#__PURE__*/ _jsx(InlineImage, {}) : /*#__PURE__*/ _jsx(SitecoreLink, {
                        field: props.fields.TargetUrl,
                        children: /*#__PURE__*/ _jsx(InlineImage, {})
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        tag: "span",
                        className: "image-caption field-imagecaption",
                        field: props.fields.ImageCaption
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx(ImageDefault, {
        ...props
    });
};
